import UserBadge from './UserBadge';

export default UserBadge;



// WEBPACK FOOTER //
// ./src/components/UserBadge/index.js